import React from "react";
import PropTypes from "prop-types";

import RenderFields from "Components/RenderFields";

import { onlyNumberKeys } from "utils";

export const inputFields = [
  {
    label: "Solar Energy",
    name: "solarEnergy",
    isRequired: true,
    placeholder: "Enter Solar Energy",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
  },
];

const SolarMeterReading = ({ formik, parentKey = "" }) => {
  return (
    <RenderFields
      formik={formik}
      parentKey={parentKey}
      inputFields={inputFields}
    />
  );
};

SolarMeterReading.propTypes = {
  formik: PropTypes.object,
  parentKey: PropTypes.string,
};

export default SolarMeterReading;
